import { createFileRoute } from '@tanstack/react-router'

import { PlatformGenerateSlipPage } from '../../../components/pages/backoffice/platform/generate-slips/platform-generate-slip-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/generate-slips')({
  component: () => (
    <PermissionChecker requiredPermissions={['slip.create']}>
      <PlatformGenerateSlipPage />
    </PermissionChecker>
  ),
})
